import { Injectable, inject } from '@angular/core';
import { EntityPagesTitle, PagesTitle } from 'src/app/app-pages-title/app-pages-title';
import { promiseWithCatch } from 'src/app/common/app.helpers';
import ProjectLinks from 'src/app/common/project.links';
import { RouteService } from 'src/app/services/route-service.abstract';
import { Project, UserRelationToGroup } from 'src/app/swagger-api';
import { ManageProjectService } from './manage-project.service';

@Injectable({ providedIn: 'root' })
export class ProjectRouteService extends RouteService<Project, EntityPagesTitle> {
  private projectService = inject(ManageProjectService);

  public constructor() {
    super();

    this.subscribeToData(this.projectService.entityChanged$);
  }

  public loadData(id: string): void {
    this.projectService.fetchEntityData(id);
  }

  public buildTitle({ title }: Project): EntityPagesTitle {
    return {
      viewPage: this.translate(PagesTitle.PROJECT_VIEW_PAGE, { projectTitle: title }),
      editPage: this.translate(PagesTitle.PROJECT_EDIT_PAGE, { projectTitle: title }),
    };
  }

  public verifyAccess(project: Project): void {
    if (project.actor_role === UserRelationToGroup.Leader || this.sessionService.isAdminSession()) {
      return;
    }

    promiseWithCatch(this.router.navigate([ProjectLinks.LINK_PROJECTS_VIEW, project.entity_id]));

    this.informService.showFailureMessage({
      title: '',
      level: 'ERROR',
      content: [{ type: 'text', value: 'MANAGE_PROJECT_NO_ACCESS_DESCRIPTION' }],
      replies: [],
    });
  }
}
